import React, { useRef } from 'react';
import { useDraggable } from 'react-use-draggable-scroll';
import { XStack } from 'tamagui';

import { useDraggingContext } from '../../hooks/useDraggingContext';

interface DraggableScrollViewProps {
  children: React.ReactNode;
  marginLeft?: any;
  paddingVertical?: any;
  paddingRight?: any;
}

export const DraggableScrollView: React.FC<DraggableScrollViewProps> = ({
  children,
  marginLeft = '$5',
  paddingVertical = '$5',
  paddingRight = 0,
}) => {
  const ref = useRef<HTMLDivElement>() as React.MutableRefObject<HTMLInputElement>;
  
  const { isDragging } = useDraggingContext();
  const { events } = useDraggable(ref, {
    isMounted: !isDragging,
  });

  return (
    <XStack
      flex={1}
      marginLeft={marginLeft}
      paddingVertical={paddingVertical}
      paddingRight={paddingRight}
      position="relative"
      overflow="scroll"
      className="hide-scrollbar"
      {...events}
      ref={ref}>
      {children}
    </XStack>
  );
};
